import template from './service-detail.html';
import controller from './service-detail.controller';

let serviceDetailComponent = {
  bindings: {},
  template,
  controller
};

export default serviceDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/service/service-detail.component.js